import React, { useState, useEffect } from 'react';
import ItemRow from './ItemRow';
import { Loading } from '../../common';
import { MdFeaturedPlayList } from "react-icons/md";
import { TbFileBarcode } from "react-icons/tb";
import { BsArrowCounterclockwise } from "react-icons/bs";

function InventoryTable({invTableProps}) {
const {isLoading,
 checkedItemsList,
 setCheckedItemsList,
  cancelApiCall,
  filterItemsType,
  stateScan,
   items,
   isDisabled,message,handleSubmitCounts,
   buttonList,
   scanHistoryArrayLength,
   showScanHistory,
   resetScanCount,
   showUpliftItems,
   setFilterItemType,
   updateCount}=invTableProps;
  const [showEmptyMessage, setShowEmptyMessage] = useState(false);

  useEffect(() => {
    if (!items || items?.length === 0) {
      setShowEmptyMessage(true);
    }else{
       setShowEmptyMessage(false);
    }
  }, [isLoading,items]);

  const onClickCheckbox=(e,id)=>{
    e.stopPropagation();
    setCheckedItemsList((prev)=>{
    return prev.includes(id)?prev.filter(itemId=>itemId!==id):[...prev,id];
    })
  }

function handleTypeSelect(selected = null) {
  setFilterItemType((prev) => ({
    all: {
      ...prev.all,
      checked: selected === 'all',
    },
    dutyFree: {
      ...prev.dutyFree,
      checked: selected === 'dutyFree',
    },
    dutyPaid: {
      ...prev.dutyPaid,
      checked: selected === 'dutyPaid',
    },
  }));
}


  return (
    <>
      <div className="flexRow justifyContentSpaceBetween">
<div className='flexRow justifyContentFlexStart width60 scanner-sel'>
<button className={`niO4u ${filterItemsType.all.scannedItemsExist ? "niO4u-scanned" : ""} ${filterItemsType.all.checked ? "niO4u-checked" : "niO4u-unselected"}`}  disabled={!filterItemsType.all.count} onClick={() => handleTypeSelect("all")}>All&nbsp;({filterItemsType.all.count})</button>
<button className={`niO4u ${filterItemsType.dutyFree.scannedItemsExist ? "niO4u-scanned" : ""} ${filterItemsType.dutyFree.checked ? "niO4u-checked" : "niO4u-unselected"}`} disabled={!filterItemsType.dutyFree.count} onClick={() => handleTypeSelect("dutyFree")}>Duty Free&nbsp;({filterItemsType.dutyFree.count})</button>
<button className={`niO4u ${filterItemsType.dutyPaid.scannedItemsExist ? "niO4u-scanned" : ""} ${filterItemsType.dutyPaid.checked ? "niO4u-checked" : "niO4u-unselected"}`} disabled={!filterItemsType.dutyPaid.count} onClick={() => handleTypeSelect("dutyPaid")}>Duty Paid&nbsp;({filterItemsType.dutyPaid.count})</button>
</div>
<div className="width40 flexRow justifyContentFlexEnd">
 <button className="grid-LOI-stylebutton-scanner-save margRight15" disabled={isDisabled|| Boolean(message?.text?.length) || Boolean(message?.error?.length)} onClick={handleSubmitCounts}>Submit</button>
        { stateScan?.scanId?<span  title='Copy Estimates'><button className="grid-button-roles-modify" onClick={showUpliftItems} disabled={buttonList??false}><MdFeaturedPlayList/></button>&nbsp;&nbsp;</span>:null}
        <button title='View Scan History' className="grid-download-btnStyle1" disabled={!scanHistoryArrayLength} onClick={showScanHistory}><TbFileBarcode/></button>&nbsp;&nbsp;
        <button  title='Reset Count' className="grid-LOI-stylebutton-rem padding0" style={{width:'32px'}} disabled={!checkedItemsList.length} onClick={()=>resetScanCount(checkedItemsList)}><BsArrowCounterclockwise/></button>
</div>

      </div>

      <div className="inv-table">
        <div className="flexRow justifyContentSpaceBetween inv-table-header">
            <span className='flexRow justifyContentFlexStart'>
          <span>Item Name</span>
          </span>
          <span className="margRight30">Count</span>
        </div>

        {isLoading ? (
          <div className="table-row selectWidgetDashboard flexCol justifyContentSpaceEvenly alignItemsCenter full-flex">
            <Loading />
            <h6 className='margTop8'>Please wait...</h6>
        <button className="margTop8 grid-download-btnStyle1" onClick={cancelApiCall}>Cancel</button>

          </div>
        ) : showEmptyMessage ? (
          <div className="table-row selectWidgetDashboard flexCol justifyContentSpaceEvenly alignItemsCenter full-flex">
            <h6>No items found</h6>
          </div>
        ) : (
          items.map((item, index) => (
            <ItemRow
              key={`${item.itemId}_${index}`}
              item={item}
              checkBoxSelect={onClickCheckbox}
              checkedItemsList={checkedItemsList}
              onIncrement={() => updateCount(index, 1)}
              onDecrement={() => updateCount(index, -1)}
            />
          ))
        )}
      </div>
    </>
  );
}

export default InventoryTable;
